module.exports = __webpack_public_path__ + "img/petstairs31.23b6ffc7.jpg";